import TableFilter from './TableFilter';
import connectContainer from './TableFilterContainer';

export default connectContainer(TableFilter);
